// extracted by mini-css-extract-plugin
export default {"btn":"tablegrid_btn__LFD+M","container":"tablegrid_container__ySv3H"};